<template>
  <div style="min-height: calc(100vh - 176px)" class="flex flex-wrap mt-4">
    <div class="relative py-2 px-2 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0" style="min-height: calc(-176px + 100vh);">
      <div class="bg-white shadow-md p-4 rounded-lg flex flex-wrap gap-4 mb-4">
        <input
          type="text"
          v-model="searchQuery"
          @input="updateFilters"
          placeholder="Поиск по ФИО, Email или Телефону..."
          class="border p-2 rounded w-full sm:w-1/3"
        />
        <select
          v-model="roleFilter"
          @change="updateFilters"
          class="border px-3 py-2 pr-7 rounded whitespace-nowrap"
        >
          <option value="">Все роли</option>
          <option value="0">Админ</option>
          <option value="1">Ученик</option>
          <option value="2">Эксперт</option>
          <option value="3">Модератор</option>
          <option value="4">Представитель компании</option>
        </select>
        <select
          v-model="sortField"
          @change="updateFilters"
          class="border px-3 py-2 pr-7 rounded whitespace-nowrap"
        >
          <option value="fio">По ФИО {{ sortOrder === 'asc' ? '↑' : '↓' }}</option>
          <option value="created_at">По дате регистрации {{ sortOrder === 'asc' ? '↑' : '↓' }}</option>
        </select>
        <button
          @click="toggleSortOrder"
          class="border px-3 py-2 rounded bg-gray-100 hover:bg-gray-200 whitespace-nowrap"
        >
          {{ sortOrder === 'asc' ? '↑ Возрастание' : '↓ Убывание' }}
        </button>
        <router-link
          to="/admin/users/create"
          class="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Создать пользователя
        </router-link>
      </div>

      <div class="bg-white shadow-md rounded-lg overflow-hidden">
        <table class="w-full text-left border-collapse">
          <thead>
            <tr class="bg-gray-200">
              <th class="p-3">#</th>
              <th class="p-3">ФИО</th>
              <th class="p-3">Логин</th>
              <th class="p-3">Email</th>
              <th class="p-3">Телефон</th>
              <th class="p-3">Роль</th>
              <th class="p-3">Активность</th>
              <th class="p-3">Активировать</th>
              <th class="p-3">Действия</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in usersList" :key="user.id" class="border-t">
              <td class="p-3">{{ index + 1 + (currentPage - 1) * perPage }}</td>
              <td class="p-3">{{ user.fio }}</td>
              <td class="p-3">{{ user.login || 'Нет логина' }}</td>
              <td class="p-3">{{ user.email || "Нет Email" }}</td>
              <td class="p-3">{{ user.phone || "Нет номера" }}</td>
              <td class="p-3">{{ user.role?.val || "Не указано" }}</td>
              <td class="p-3">
                <span :class="user.is_enabled ? 'text-green-600' : 'text-red-600'">
                  {{ user.is_enabled ? "Активен" : "Неактивен" }}
                </span>
              </td>
              <td class="p-3">
                <button
                  @click="toggleUserEnabled(user, index)"
                  :class="user.is_enabled ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600'"
                  class="text-white px-3 py-1 rounded transition w-full"
                >
                  {{ user.is_enabled ? 'Заблокировать' : 'Активировать' }}
                </button>
              </td>
              <td class="p-3 flex gap-2 items-center">
                <router-link 
                  :to="`/admin/users/edit/${user.id}`" 
                  class="bg-blue-500 text-white px-3 py-1 rounded"
                >
                  Редактировать
                </router-link>
                <router-link 
                  v-if="user.role && user.role.key == 2"
                  :to="`/admin/experts/edit/${user.id}?is_user=1`" 
                  class="bg-emerald-500 text-white px-3 py-1 rounded"
                >
                  Профиль
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex justify-center mt-4">
        <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1" class="px-4 py-2 bg-gray-300 rounded mr-2">
          ← Назад
        </button>
        <span class="px-4 py-2">Страница {{ currentPage }} из {{ totalPages }}</span>
        <button @click="changePage(currentPage + 1)" :disabled="currentPage >= totalPages" class="px-4 py-2 bg-gray-300 rounded ml-2">
          Вперед →
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_USERS, HEADERS_TOKEN_JSON } from "@/const/uri";

export default {
  data() {
    return {
      usersList: [],
      searchQuery: "",
      roleFilter: "",
      currentPage: 1,
      perPage: 10,
      totalPages: 1,
      sortField: "fio",
      sortOrder: "asc",
    };
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler() {
        this.fetchUsers();
      },
    },
  },
  mounted() {
    this.fetchUsers();
  },
  methods: {
    async fetchUsers() {
      const query = this.$route.query;
      this.searchQuery = query.search || "";
      this.roleFilter = query.role !== undefined ? query.role : "";
      this.currentPage = Number(query.page) || 1;
      this.sortField = query.sort || "fio";
      this.sortOrder = query.order || "asc";

      const orderingField = this.sortOrder === 'desc' ? `-${this.sortField}` : this.sortField;

      await axios({
        method: "GET",
        url: API_USERS.list,
        params: {
          search: this.searchQuery,
          role: this.roleFilter || undefined,
          p: this.currentPage,
          page_size: this.perPage,
          ordering: orderingField,
        },
        headers: HEADERS_TOKEN_JSON(),
      })
        .then((e) => {
          if (e.data.code === 0) {
            const responseData = e.data.data;
            this.usersList = responseData.results;
            this.totalPages = Math.ceil(responseData.count / this.perPage);
          }
        })
        .catch((e) => {
          console.error("Ошибка загрузки пользователей:", e);
        });
    },
    toggleSortOrder() {
      this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      this.updateFilters();
    },
    updateFilters() {
      this.$router.push({
        query: {
          search: this.searchQuery || undefined,
          role: this.roleFilter || undefined,
          sort: this.sortField,
          order: this.sortOrder,
          page: 1,
        },
      });
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.$router.push({ query: { ...this.$route.query, page } });
      }
    },
    async toggleUserEnabled(user) {
        if (!user.id) return;
        try {
          await axios.post(
            `${API_USERS.list}${user.id}/toggle-enabled/`,
            {},
            { headers: HEADERS_TOKEN_JSON() }
          );
          this.fetchUsers();
        } catch (e) {
          alert('Ошибка управления активностью');
          console.error(e);
        }
      },
  },
};
</script>
